/*
 * Lumora — cart-drawer fix
 * -------------------------------------------------------------
 * The custom offer section (sections/lumera-product-main.liquid) renders its
 * "Add to cart" button (.lb-cta) inside a plain {% form 'product' %} that is
 * NOT wrapped in the theme's <product-form> element. With nothing to intercept
 * the submit, the browser posts to /cart/add and hard-redirects to /cart, so
 * the slide-out cart drawer never opens.
 *
 * This script intercepts that submit, adds via AJAX (preserving every form
 * input, including the Kaching Bundles property), and opens the existing
 * <cart-drawer> using its own renderContents() API — exactly how the theme's
 * <product-form> element would. If the drawer or its API is unavailable, it
 * falls back to the original native submit so add-to-cart never breaks.
 */
(function () {
  function bindForm(form) {
    if (!form || form.dataset.lbAjaxBound) return;
    var btn = form.querySelector('.lb-cta');
    if (!btn) return;
    form.dataset.lbAjaxBound = '1';

    form.addEventListener('submit', function (e) {
      var cart = document.querySelector('cart-drawer');
      // No drawer on this page (or old browser) -> let the native submit run.
      if (!cart || typeof cart.renderContents !== 'function') return;

      e.preventDefault();
      if (btn.getAttribute('aria-disabled') === 'true') return;

      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading');
      var originalHTML = btn.innerHTML;
      btn.innerHTML = 'Adding…';

      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

      var config;
      try {
        config = fetchConfig('javascript');
      } catch (_) {
        config = { method: 'POST', headers: { Accept: 'application/json' } };
      }
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      // Let the browser set the multipart boundary for FormData.
      if (config.headers['Content-Type']) delete config.headers['Content-Type'];

      var fd = new FormData(form);
      try {
        var sectionIds = cart
          .getSectionsToRender()
          .map(function (s) { return s.id; })
          .join(',');
        fd.append('sections', sectionIds);
      } catch (_) {}
      fd.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
      config.body = fd;

      fetch(addUrl, config)
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status) {
            // Cart error (e.g. out of stock): fall back to the native cart page.
            form.submit();
            return;
          }
          cart.renderContents(res); // updates drawer + icon bubble, then opens it
        })
        .catch(function (err) {
          console.error('[lb cart-drawer fix]', err);
          form.submit();
        })
        .finally(function () {
          btn.classList.remove('loading');
          btn.removeAttribute('aria-disabled');
          btn.innerHTML = originalHTML;
        });
    });
  }

  function init() {
    var buttons = document.querySelectorAll('.lb-cta');
    for (var i = 0; i < buttons.length; i++) {
      var form = buttons[i].closest('form');
      if (form) bindForm(form);
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
